
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Storia',
	'noDashboardFound': 'Impossibile recuperare la storia. È possibile che non esista o che non si dispone dei privilegi sufficienti per visualizzarlo.',
	'noDashboardCapability': 'L\'utente non dispone della possibilità di utilizzare le storie.',
	'noDashboardPermision': 'L\'utente non dispone dei privilegi sufficienti per visualizzare questa storia',
	'defaultName': 'Nuova storia',
	'storyProperties': 'Proprietà storia',
	'createAvDataStoryLabel': 'Storia',
	'createAvSlideShowLabel': 'Presentazione',
	'createAvPanAndZoomLabel': 'Viaggio guidato',
	'dashboard_save_success': 'La storia è stata salvata.',
	'cmEmptySelection': 'La storia è stata eliminata. Provare a salvare una nuova storia.',
	'createStoryTitle': 'Crea una storia',
	'transitionStyleTitle': 'Stile transizione',
	'createButton': 'Crea',
	'cancelButton': 'Annulla',
	'dashboardResetTitle': 'Reimposta storia',
	'dashboardResetMessage': 'Sei sicuro di voler ripristinare tutte le modifiche applicate a questa storia?',
	'dashboardResetToast': 'La tua storia è stata resettata.',
	'filter_drag_and_drop_all_tabs': 'Trascinare e rilasciare i dati in questo punto per filtrare tutte le scene.',
	'filter_drag_and_drop_current_tab': 'Trascinare e rilasciare i dati in questo punto per filtrare questa scena.',
	'filterIconLabel_Global': 'Tutte le scene',
	'filterIconLabel_Tab': 'Questa scena',
	'filterIconTooltip_Global': 'Tutte le scene',
	'filterIconTooltip_Tab': 'Questa scena',
	'filterOverflowMenu_Global': 'Menu di overflow di tutte le scene',
	'filterOverflowMenu_Tab': 'Menu di overflow di questa scena',
	'renameScene': 'Rinomina scena',
	'duplicateScene': 'Duplica scena',
	'deleteScene': 'Elimina scena',
	'editTimelineHighlight': 'Modifica evidenziazione',
	'deleteTimelineHighlight': 'Elimina evidenziazione',
	'filter_includesAll': 'Include tutto',
	'timeline_highlight_moved_to': 'Evidenziazione sequenza temporale %{id} spostata in %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Seleziona',
	'newDefaultStoryName': 'Storia: %{modelName}',
	'exportLabel': 'Salva',
	'exportAsLabel': 'Salva con nome:',
	'exportDialogTitle': 'Salva come una storia',
	'exportDialogFooter': 'Pulsante Salva e Annulla',
	'loadAfterExportLabel': 'Apri la storia dopo averla salvata',
	'selectTemplateLabel': 'Seleziona un modello',
	'outOfBoundsWarningMessage': 'Alcuni caselle di testo del dashboard si trovano all\'esterno della griglia e potrebbero non essere visualizzati correttamente dopo l\'esportazione.',
	'emptyExploreCardsWarningMessage': 'Le schede vuote vengono eliminate durante il salvataggio come storia.',
	'dashboard_export_success': 'La dashboard è stata salvata come una storia.',
	'explore_export_success': 'L\'esplorazione è stata salvata come una storia.',
	'toastUpgradeDone': 'La storia è stata aggiornata. Salvare ora per mantenere prestazioni ottimali.',
	'navigationMarker': 'Contrassegno di navigazione',
	'navigateMarkers': 'Esplora contrassegni',
	'navNextMarker': 'Contrassegno successivo',
	'navPrevMarker': 'Contrassegno precedente',
	'navPrevMarkerAbbreviated': 'Contrassegno prec',
	'timelineSettingsButton': 'Opzioni di riproduzione',
	'autoPlay': 'Riproduci tutte le scene',
	'loop': 'Loop',
	'refreshData': 'Aggiorna all\'avvio',
	'slideshowLabel': 'Presentazione',
	'panAndZoomLabel': 'Viaggio guidato',
	'slideShowLayoutLabel': 'Layout presentazione',
	'panAndZoomLayoutLabel': 'Layout viaggio guidato',
	'panAndZoomLayoutFooter': 'Un Layout viaggio guidato è una raccolta di scene in una singola area di lavoro. Quando si esegue questo tipo di storia, la presentazione ingrandisce ed esegue la panoramica di ciascuna singola scena in ordine sequenziale. Si differenzia dal Layout presentazione in cui ciascuna scena viene presentata in un\'area di lavoro diversa. Il Layout viaggio guidato con tre scene collegate da linee, consente di creare una sequenza orizzontale di scene. Ciò è utile quando si desidera visualizzare una sequenza temporale.',
	'PanAndZoomLayout1': '5 scene disposte in una forma rettangolare',
	'PanAndZoomLayout2': '4 scene disposte in una forma a scala da sinistra a destra',
	'PanAndZoomLayout3': '6 scene disposte in una forma rettangolare',
	'PanAndZoomLayout4': '7 scene disposte in una forma rettangolare, con 6 scene di piccole dimensioni in alto ed 1 scena di grandi dimensioni in basso',
	'PanAndZoomLayout5': '3 scene disposte con 2 scene di piccole dimensioni in alto ed 1 scena di grandi dimensioni in basso.',
	'PanAndZoomLayout6': 'Una sequenza di 4 scene disposte in orizzontale',
	'pageSelectWarning': 'Selezionare una scena.',
	'noSceneTransitionLabel': 'Nessuno',
	'sceneTransitionPropertyLabel': 'Transizione scena',
	'animatedPathSceneTransitionLabel': 'Percorso animato',
	'sweepSceneTransitionLabel': 'Ignora',
	'storyTypeLabel': 'Tipo di storia',
	'layoutLabel': 'Layout',
	'tabName_animation': 'Animazione',
	'propAniAnimation': 'Animazione',
	'propAniTypeEntrance': 'Animazione entrata',
	'propAniDirectionIn': 'Direzione entrata',
	'propAniTypeExit': 'Animazione uscita',
	'propAniDirectionOut': 'Direzione uscita',
	'propAniDirection': 'Direzione',
	'propAniEntrance': 'Entrata',
	'propAniTypeEntranceSlideIn': 'Scorrimento in entrata',
	'propAniTypeEntranceFadeIn': 'Dissolvenza in entrata',
	'propAniTypeEntrancePivotIn': 'Pivot in entrata',
	'propAniTypeEntranceScaleIn': 'Scalabilità in entrata',
	'propAniTypeEntranceShrinkIn': 'Riduci in entrata',
	'propAniDirectionInLeft': 'Da sinistra',
	'propAniDirectionInRight': 'Da destra',
	'propAniDirectionInTop': 'Dall\'alto',
	'propAniDirectionInBottom': 'Dal basso',
	'propAniExit': 'Esci',
	'propAniTypeExitSlideIn': 'Scorrimento in uscita',
	'propAniTypeExitFadeIn': 'Dissolvenza in uscita',
	'propAniTypeExitPivotOut': 'Pivot in uscita',
	'propAniTypeExitScaleIn': 'Scalabilità in uscita',
	'propAniTypeExitExpandOut': 'Espandi in uscita',
	'propAniDirectionOutLeft': 'Verso sinistra',
	'propAniDirectionOutRight': 'Verso destra',
	'propAniDirectionOutTop': 'Verso l\'alto',
	'propAniDirectionOutBottom': 'Verso il basso',
	'propAniEntranceTime': 'Inizia a (sec):',
	'propAniExitTime': 'Termina a (sec):',
	'animationNoEntranceText': 'L\'animazione di entrata non verrà eseguita se il widget si trova all\'inizio della scena.',
	'animationNoExitText': 'L\'animazione di uscita non verrà eseguita se il widget si trova alla fine della scena.',
	'propAniTypeDataEntrance': 'Ingresso dati',
	'propAniRevealDuration': 'Durata animazione entrata',
	'timelineAnimationProperties': 'Apri proprietà animazione',
	'scenesPropertiesSection': 'Scene',
	'editStoryCoachMarkTitle': 'Modifica storia',
	'editStoryCoachMarkContents': 'Fare clic sull\'icona matita per modificare questa storia.',
	'addDataStoryCoachMarkContents': 'Trascinare e rilasciare i dati dal pannello di dati nella proprio storia.',
	'expandSceneCoachmarkTitle': 'Apri sequenza temporale',
	'expandSceneCoachmarkContents': 'Animare una scena regolando la visibilità dell\'oggetto in base al tempo ed alla durata.',
	'overviewCoachmarkTitle': 'Scene Panoramica',
	'overviewCoachmarkContents': 'Utilizzare le scene Panoramica per avviare e terminare la storia per rappresentare il quadro generale di tutte le scene. Da una scena panoramica, fare clic e trascinarla per scambiarla con altre scene. È possibile visualizzare o nascondere le scene panoramica nelle proprietà della storia.',
	'animatedPathCoachmarkTitle': 'Percorso animato',
	'animatedPathCoachmarkContents': 'Per animare un oggetto da una scena ad un\'altra, duplicare una scena con un oggetto. Quindi, spostare, ridimensionare o ruotare l\'oggetto duplicato nella nuova scena.',
	'propShowStoryOverviewFirstSlide': 'Mostra tutte le scene all\'avvio',
	'propShowStoryOverviewLastSlide': 'Mostra tutte le scene alla fine',
	'storySceneSingleCountLabel': 'una scena',
	'storySceneCountLabel': '%{count} scene',
	'storySceneRangeCountLabel': 'Scena %{index} di %{count}',
	'storySceneExpand': 'Apri sequenza temporale',
	'storySceneActionMenu': 'Menu opzioni scena di avvio',
	'timelineRightContainerLabel': 'Gruppo controllo pulsante sequenza temporale',
	'timelineViewLabel': 'Sequenza temporale',
	'timelineZoomFit': 'Adatta',
	'timelineZoomIn': 'Zoom avanti',
	'timelineZoomOut': 'Zoom indietro',
	'timelinePositionIndicator': 'indicatore di posizione sequenza temporale in %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'sposta indicatore di posizione sequenza temporale a sinistra in %{position}',
	'timelinePositionIndicatorMoveRightTo': 'sposta indicatore di posizione sequenza temporale a destra in %{position}',
	'sceneStart': 'Vai all\'inizio della scena %{position}',
	'sceneEnd': 'Vai alla fine della scena %{position}',
	'timelineHighlightTitle': 'Evidenziazione',
	'addTimelineHighlight': 'Aggiungi evidenziazione',
	'addSceneBtnTitle': 'Aggiungi una nuova scena con modello predefinito',
	'addSceneChevronBtnTitle': 'Scegliere un modello di scena',
	'timelinePlay': 'Riproduci',
	'timelinePause': 'Pausa',
	'sceneNavigation': 'Navigazione scena',
	'navNextScene': 'Scena successiva',
	'navPrevScene': 'Scena precedente',
	'navPrevSceneAbbreviated': 'Anteprima scena',
	'navExitFullScreen': 'Esci dalla modalità schermo intero',
	'navToggleOverview': 'Attiva/disattiva panoramica',
	'rowNumber': 'Riga %{number}',
	'overviewBtnLabel': 'Panoramica',
	'sceneListStart': 'Inizio panoramica',
	'sceneListEnd': 'Fine panoramica',
	'timelineLeftHandle': 'handle sinistro per %{name}',
	'timelineRightHandle': 'handle destro per %{name}',
	'timelineLeftHandleNoTitle': 'handle sinistro',
	'timelineRightHandleNoTitle': 'handle destro',
	'timelineMoveLeft': 'Sposta %{object} a sinistra',
	'timelineMoveRight': 'Sposta %{object} a destra',
	'timelineMoveWidget': 'widget sequenza temporale spostato in %{newStartTime} e %{newEndTime}',
	'timelineMoveWidgetStartTime': 'ora di inizio widget sequenza temporale modificata in %{newStartTime}',
	'timelineMoveWidgetEndTime': 'ora di fine widget sequenza temporale modificata in %{newEndTime}',
	'timelineMoveWidgetDown': 'widget sequenza temporale spostato in basso',
	'timelineMoveWidgetUp': 'widget sequenza temporale spostato in alto',
	'addSceneTitle': 'Aggiungi una scena',
	'blankSceneLayout': 'Vuoto',
	'titleSceneLayout': 'Titolo con sottotitolo',
	'sceneLayout1': 'Titolo con testo accanto ad una visualizzazione',
	'sceneLayout2': 'Titolo con una visualizzazione',
	'sceneLayout3': 'Titolo con due visualizzazioni',
	'sceneLayout4': 'Multifunzione',
	'sceneLayout5': 'Nessun titolo con testo accanto ad una visualizzazione',
	'sceneLayout6': 'Multifunzione 2 per 2',
	'sceneLayout7': 'Multifunzione 2 accanto a 1',
	'sceneLayout8': 'Multifunzione 1 accanto a 2',
	'sceneLayout9': 'Multifunzione 1 su 2',
	'sceneLayout10': 'Multifunzione 2 su 1',
	'sceneLayout11': 'Multifunzione 4 su 1',
	'sceneLayout12': 'Multifunzione 1 su 1 accanto a 2 per 2 su 1',
	'titleWidgetPlaceholderText': 'Immettere il titolo qui',
	'subtitleWidgetPlaceholderText': 'Immettere il sottotitolo qui',
	'createStoryViewTitle': 'Crea storia',
	'defaultStoryName': 'Nuova storia',
	'screenshot_label': 'Storia %{title}',
	'screenshot_label_scene': 'Scena %{sceneTitle} della storia %{title}',
	'filmstripHandleOpenLabel': 'Apri selettore di scena',
	'filmstripHandleCloseLabel': 'chiudi selettore di scena'
});
